import styled from "styled-components";
import { Card } from 'react-bootstrap'; 

export const StyledCard = styled(Card)`
	border-radius: 15px; 
	border: None;

`